export default {
      id: "phone-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#phone",
      toString: function () {
        return this.url;
      }
    }